// Screens where the Player is busy somewhere the app cannot see — a payment gateway inside an
// iframe, a QR code being scanned with a phone — hold the idle auto-logout while they are open:
// the short idle limit becomes a few minutes (see useAutoLogout). Without it a Player waiting on a
// payment would be signed out in the middle of it.

let holds = 0;

/** Relax the idle auto-logout. Returns the function that releases this hold. */
export function holdAutoLogout(): () => void {
  holds += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holds = Math.max(0, holds - 1);
  };
}

export function isAutoLogoutHeld(): boolean {
  return holds > 0;
}

/** Test helper — clear every hold between Jest cases. */
export function __resetAutoLogoutHoldsForTests(): void {
  holds = 0;
}
